import FeatureGates, { GetExperimentValueOptions } from '@atlaskit/feature-gate-js-client';

export const useExperimentValue = (
  name: string,
  parameter: string,
  defaultValue: boolean,
  options?: GetExperimentValueOptions<any> | undefined
): boolean | undefined => {
  return FeatureGates.getExperimentValue(name, parameter, defaultValue, options);
};
